import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    domain: "https://app.almujtama.com.sa",
    localization: "ar",
    limit: 10,
    showMenu: false
  }

});

